import React, { useState } from "react";
import "./paymentType.scss";
import { Stack } from "@mui/material";

// Icon
import { GiCash } from "react-icons/gi";
import { SiRazorpay } from "react-icons/si";

const PaymentType = ({ selectPaymentType, setSelectPaymentType }) => {
  return (
    <div className="payment-type">
      <div className="main-title">Payment</div>
      {process.env.REACT_APP_ONLINE_PAYMENT === "false" && (
        <div>
          Online payment is temporarily disabled for certain reasons; however,
          you can still choose cash on delivery.
        </div>
      )}
      <Stack className="types" spacing={3}>
        <div
          className={`online type ${
            selectPaymentType === "online" && "active"
          }`}
          onClick={() =>
            process.env.REACT_APP_ONLINE_PAYMENT === "true" &&
            setSelectPaymentType("online")
          }
        >
          <div className="title-and-image">
            <div className="title">Online</div>
            <div className="image">
              <SiRazorpay size="32px" color="#050a30" />
            </div>
          </div>
          <div className="short-description">
            We support Mastercard, Visa, G-Pay, Paytm and UPI.
          </div>
        </div>
        <div
          className={`cash type ${selectPaymentType === "cash" && "active"}`}
          onClick={() => setSelectPaymentType("cash")}
        >
          <div className="title-and-image">
            <div className="title">Cash</div>
            <div className="image">
              <GiCash size="32px" color="#050a30" />
            </div>
          </div>
          <div className="short-description">
            Pay with cash when your order is delivered.
          </div>
        </div>
      </Stack>
    </div>
  );
};

export default PaymentType;
